import cookieHelpers from './helpers'
import axios from 'axios'
export default {
  updateCountryCode ({state, commit, rootState}, {countryCode}) {
    if (state.supportedZones.indexOf(countryCode) === -1) {
      countryCode = 'gb'
    }
    cookieHelpers.setCookie(countryCode)
    commit('SET_COUNTRY_CODE', { countryCode: countryCode })
  },
  loadCountryCode ({state, commit, rootState, dispatch}) {
    let cookieVal = cookieHelpers.getCookie()
    if (!cookieVal && state.googleAPIKey) {
      dispatch('googleAPIRequest')
        .then((data) => {
          dispatch('updateCountryCode', { countryCode: data.countryCode.toLowerCase() })
        }, (err) => {
          console.log(err.message)
          dispatch('updateCountryCode', { countryCode: 'gb' })
        })
      return
    }
    dispatch('updateCountryCode', { countryCode: (cookieVal !== '' ? cookieVal : 'gb') })
  },
  googleAPIRequest ({state, commit, rootState}) {
    return new Promise((resolve, reject) => {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition((pos) => {
          axios.get(`https://maps.googleapis.com/maps/api/geocode/json?latlng=${pos.coords.latitude},${pos.coords.longitude}&key=${state.googleAPIKey}`)
            .then((res) => {
              let found = false
              res.data.results.forEach((obj) => {
                obj.address_components.forEach((component) => {
                  if (component.types.indexOf('country') > -1) {
                    found = true
                    resolve({ countryCode: component.short_name })
                  }
                })
              })
              if (!found) {
                reject('Country not found')
              }
            }, (err) => {
              reject('Error with Google API request - ' + err.message)
            })
        })
      } else {
        reject('Browser does not support geolocation')
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/modules/geolocation/store/actions.js